// extracted by mini-css-extract-plugin
module.exports = {"prevCard":"ConfirmTestForm_prevCard__32mrQ","prevCardWrapper":"ConfirmTestForm_prevCardWrapper__36s5t","cardError":"ConfirmTestForm_cardError__av4Lk"};